// 获取考试题目
import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    _type: number; // 新老考试的区分
    element_id: number;
    page: number;
    size: number;
    student_id?: number; // 随机考试，每个人不同，默认是当前登录用户
    user_id?: string;
    is_finished?: number;
}

export const getQuizQuestionList = (data: IInput): Promise<IListResponse<IQuizSectionInfo>> => {
    return fetchData(Api.GET_QUIZ_QUESTION_LIST, data).then((res: IListResponse<IQuizSectionInfo>) => {
        return res;
    });
};
